var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$store.state.webNavigator == "pc"
    ? _c("div", { staticClass: "row flexSpace" }, [
        _c(
          "div",
          {
            style: {
              width: 63 * (100 / 960) + "vw",
              height: 25 * (100 / 960) + "vw",
              borderRadius: 50 + "%",
              cursor: "pointer"
            },
            on: { click: _vm.blackHomePage }
          },
          [
            _c("img", {
              style: {
                width: 63 * (100 / 960) + "vw",
                height: 25 * (100 / 960) + "vw",
                borderRadius: 50 + "%"
              },
              attrs: { src: _vm.src, title: "脂玫乐健康瘦身网", alt: "脂玫乐" }
            })
          ]
        ),
        _c("div", { staticClass: "locate-keyword firstText" }, [
          _vm._v("\n    健康瘦身 发现更好的自己\n  ")
        ]),
        _c(
          "div",
          {
            staticClass: "phone-number firstText",
            style: {
              whiteSpace: "nowrap",
              display: "inline-block",
              fontSize: 11 * (100 / 960) + "vm",
              fontFamily: "MicrosoftYaHei",
              fontWeight: "bold",
              color: "#00CDA2"
            }
          },
          [_vm._v("400-6090-399")]
        ),
        _c(
          "div",
          {
            staticStyle: {
              flex: "1",
              display: "flex",
              "justify-content": "flex-end"
            }
          },
          [
            _c(
              "ul",
              { staticClass: "list-ul flexStart" },
              _vm._l(_vm.bararr, function(item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    staticClass: "list-li pointEr",
                    style: {
                      position: "relative",
                      display: "inline-block",
                      marginRight: 10 * (100 / 960) + "vw",
                      fontSize: 8 * (100 / 960) + "vw",
                      lineHeight: 20 * (100 / 960) + "vw",
                      fontFamily: "MicrosoftYaHei",
                      fontWeight: 400,
                      color: "#999"
                    },
                    on: {
                      click: function($event) {
                        return _vm.path(item, index)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "top-a",
                        class: { Active: _vm.TopAct == index + 1 }
                      },
                      [
                        index == 3
                          ? _c(
                              "div",
                              { staticClass: "list-div" },
                              _vm._l(_vm.toplist, function(item1, index1) {
                                return index1 == 0
                                  ? _c(
                                      "div",
                                      { key: index1, staticClass: "list-top" },
                                      [
                                        _c(
                                          "ul",
                                          _vm._l(item1.data, function(
                                            item2,
                                            index
                                          ) {
                                            return _c(
                                              "li",
                                              {
                                                key: index,
                                                style: {
                                                  whiteSpace: "nowrap",
                                                  fontSize:
                                                    8 * (100 / 960) + "vw",
                                                  fontFamily: "MicrosoftYaHei",
                                                  fontWeight: 400,
                                                  color: "#000000",
                                                  lineHeight:
                                                    14 * (100 / 960) + "vw",
                                                  display: "block"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.gotoPath(
                                                      item2,
                                                      index
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(item2.text) +
                                                    "\n                "
                                                )
                                              ]
                                            )
                                          }),
                                          0
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              }),
                              0
                            )
                          : _vm._e(),
                        index == 1
                          ? _c("div", { staticClass: "list-div" }, [
                              _c("div", { staticClass: "list-top" }, [
                                _c(
                                  "ul",
                                  _vm._l(item.jfallist, function(
                                    item1,
                                    index1
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        key: index1,
                                        staticClass: "change-color",
                                        on: {
                                          click: function($event) {
                                            return _vm.path(item1)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(item1.name) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ])
                            ])
                          : _vm._e(),
                        _c("div", { staticClass: "firstName" }, [
                          _vm._v(_vm._s(item.name))
                        ])
                      ]
                    )
                  ]
                )
              }),
              0
            )
          ]
        )
      ])
    : _c("div", [
        _vm.TopAct == "6" || _vm.TopAct == "0" || _vm.TopAct == "2"
          ? _c(
              "div",
              {
                staticClass: "big-box row flexSpace",
                style: {
                  position: "fixed",
                  top: 0,
                  left: 0,
                  right: 0,
                  zIndex: 99,
                  height: 110 * (100 / 750) + "vw",
                  backgroundSize: "cover",
                  paddingLeft: 30 * (100 / 750) + "vw",
                  paddingRight: 30 * (100 / 750) + "vw"
                }
              },
              [
                _c("div", [
                  _c("img", {
                    style: {
                      width: 148 * (100 / 960) + "vw",
                      height: 58 * (100 / 960) + "vw",
                      marginRight: 28 * (100 / 960) + "vw",
                      cursor: "pointer"
                    },
                    attrs: {
                      title: "脂玫乐健康瘦身网",
                      src: _vm.src1,
                      alt: "脂玫乐"
                    },
                    on: { click: _vm.blackHomePage }
                  }),
                  _vm._m(0)
                ]),
                _c(
                  "div",
                  {
                    staticClass: "positionID",
                    style: {
                      width: 84 * (100 / 750) + "vw",
                      height: 34 * (100 / 750) + "vw"
                    },
                    on: { click: _vm.downloadApp }
                  },
                  [
                    _c("img", {
                      staticStyle: { width: "100%", height: "100%" },
                      attrs: { src: _vm.src2, alt: "", title: "" }
                    })
                  ]
                ),
                _c(
                  "div",
                  {
                    style: {
                      width: 41 * (100 / 750) + "vw",
                      height: 34 * (100 / 750) + "vw"
                    },
                    on: { click: _vm.showMainNav }
                  },
                  [
                    _c("img", {
                      class: this.$store.state.mainNavShowStatus
                        ? "more-icon2"
                        : "more-icon",
                      attrs: {
                        alt: "",
                        title: "",
                        src: this.$store.state.mainNavShowStatus
                          ? _vm.src3
                          : _vm.src4
                      }
                    })
                  ]
                )
              ]
            )
          : _c(
              "div",
              {
                staticClass: "big-box2 row flexSpace",
                style: {
                  position: "fixed",
                  top: 0,
                  left: 0,
                  right: 0,
                  zIndex: 99,
                  height: 110 * (100 / 750) + "vw",
                  backgroundSize: "cover",
                  paddingLeft: 30 * (100 / 750) + "vw",
                  paddingRight: 30 * (100 / 750) + "vw"
                }
              },
              [
                _c("div", [
                  _c("img", {
                    style: {
                      width: 148 * (100 / 960) + "vw",
                      height: 58 * (100 / 960) + "vw",
                      marginRight: 28 * (100 / 960) + "vw",
                      cursor: "pointer"
                    },
                    attrs: {
                      title: "脂玫乐健康瘦身网",
                      src: _vm.src5,
                      alt: "脂玫乐"
                    },
                    on: { click: _vm.blackHomePage }
                  }),
                  _vm._m(1)
                ]),
                _c(
                  "div",
                  {
                    staticClass: "positionID",
                    style: {
                      width: 84 * (100 / 750) + "vw",
                      height: 34 * (100 / 750) + "vw"
                    },
                    on: { click: _vm.downloadApp }
                  },
                  [
                    _c("img", {
                      staticStyle: { width: "100%", height: "100%" },
                      attrs: { src: _vm.src6, alt: "", title: "" }
                    })
                  ]
                ),
                _c(
                  "div",
                  {
                    style: {
                      width: 41 * (100 / 750) + "vw",
                      height: 34 * (100 / 750) + "vw"
                    },
                    on: { click: _vm.showMainNav }
                  },
                  [
                    _c("img", {
                      class: this.$store.state.mainNavShowStatus
                        ? "more-icon2"
                        : "more-icon",
                      attrs: {
                        alt: "",
                        title: "",
                        src: this.$store.state.mainNavShowStatus
                          ? _vm.src7
                          : _vm.src8
                      }
                    })
                  ]
                )
              ]
            )
      ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "displayIB colffffff" }, [
      _c("p", { staticClass: "font16phone" }, [
        _vm._v("健康瘦身 发现更好的自己")
      ]),
      _c("p", { staticClass: "font25phone fontWeightB" }, [
        _vm._v("400-6090-399")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "displayIB col666666" }, [
      _c("p", { staticClass: "font16phone" }, [
        _vm._v("健康瘦身 发现更好的自己")
      ]),
      _c("p", { staticClass: "font25phone fontWeightB col00CDA2" }, [
        _vm._v("400-6090-399")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ddb8763", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ddb8763","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopNavigation/TopNavigation.vue
// module id = 776
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17